export var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
})(KeyCode || (KeyCode = {}));
